"use strict";
/**
 * RD-11 (Anthony's Rule 2; Paul approved report 131, 2026-10-14): one plain-English
 * definition each for monthly income, bills and money left over, the same on every
 * page of both apps. The figures come from the server's `typical_month`
 * (`snapshot.typical_month` on `/insights/`); nothing recomputes them on a client.
 *
 * Each definition is the approved sentence, then the approved detail, word for word.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.INCOME_KEPT_NOTE_COPY = exports.INCOME_UNDO_KEEP_COPY = exports.INCOME_REMOVE_COPY = exports.INCOME_KEEP_COPY = exports.INCOME_STILL_EXPECTING_COPY = exports.SHARES_OF_MONTHLY_INCOME_COPY = exports.TOTAL_DEPOSITS_LABEL_COPY = exports.DEPOSITS_ONE_OFF_SUFFIX_COPY = exports.MONEY_LEFT_OVER_DESCRIPTOR_COPY = exports.EXTRA_DEBT_PAYMENTS_LABEL_COPY = exports.MONTHLY_AVERAGE_COPY = exports.BILLS_DESCRIPTOR_COPY = exports.MONTHLY_INCOME_DESCRIPTOR_COPY = exports.AVERAGE_DEPOSITS_LABEL_COPY = exports.CONFIRM_YOUR_PAYCHECK_COPY = exports.PAYCHECK_NOT_FOUND_COPY = exports.MONEY_LEFT_OVER_DEFINITION_COPY = exports.BILLS_DEFINITION_COPY = exports.MONTHLY_INCOME_DEFINITION_COPY = exports.MONEY_LEFT_OVER_LABEL_COPY = exports.SAVING_LABEL_COPY = exports.EVERYDAY_SPENDING_LABEL_COPY = exports.BILLS_LABEL_COPY = exports.MONTHLY_INCOME_LABEL_COPY = void 0;
exports.typicalMonthAverageCopy = typicalMonthAverageCopy;
exports.extraDebtDescriptorCopy = extraDebtDescriptorCopy;
exports.definitionButtonLabel = definitionButtonLabel;
exports.typicalMonthOverCopy = typicalMonthOverCopy;
exports.averageDepositsLabelCopy = averageDepositsLabelCopy;
exports.incomeStoppedCopy = incomeStoppedCopy;
exports.incomeWaitingCopy = incomeWaitingCopy;
exports.MONTHLY_INCOME_LABEL_COPY = "Monthly income";
exports.BILLS_LABEL_COPY = "Bills";
exports.EVERYDAY_SPENDING_LABEL_COPY = "Everyday spending";
exports.SAVING_LABEL_COPY = "Saving";
exports.MONEY_LEFT_OVER_LABEL_COPY = "Money left over";
exports.MONTHLY_INCOME_DEFINITION_COPY = "What your regular paychecks bring in, in a typical month. It's the sum of the paychecks we've detected (or that you've confirmed or edited), each converted to a monthly amount. One-off money isn't counted: bonuses, refunds, payments from friends, and moving money between your own accounts.";
exports.BILLS_DEFINITION_COPY = "Payments that repeat on a schedule, converted to a monthly amount: housing, utilities, insurance, phone and internet, loan payments and subscriptions. Money you move to savings is saving, not a bill.";
exports.MONEY_LEFT_OVER_DEFINITION_COPY = "What's left of your monthly income after a typical month of bills, everyday spending and saving. Saving is the 12-month average of transfers to savings and goal contributions. Everyday spending is everything else you spent, averaged over your last 12 complete months, including purchases without a category.";
/** Option (a), Paul 2026-10-14: no paycheck found, so no income and no left-over figure.
 *  The app never invents a pay period. */
exports.PAYCHECK_NOT_FOUND_COPY = "Not found yet";
exports.CONFIRM_YOUR_PAYCHECK_COPY = "Confirm your paycheck";
/** Review my data: every income deposit per month, one-off money included. Never
 *  called monthly income. */
exports.AVERAGE_DEPOSITS_LABEL_COPY = "Average deposits, last 12 months";
/* The tiles' and cards' secondary lines, shared so web and mobile say the same words
 * (rule 17, mobile's RD-11 half). */
exports.MONTHLY_INCOME_DESCRIPTOR_COPY = "Regular paychecks, per month";
exports.BILLS_DESCRIPTOR_COPY = "Scheduled, per month";
exports.MONTHLY_AVERAGE_COPY = "Monthly average";
exports.EXTRA_DEBT_PAYMENTS_LABEL_COPY = "Extra debt payments";
exports.MONEY_LEFT_OVER_DESCRIPTOR_COPY = "Each typical month";
exports.DEPOSITS_ONE_OFF_SUFFIX_COPY = "/mo, one-off money included";
exports.TOTAL_DEPOSITS_LABEL_COPY = "Total deposits";
exports.SHARES_OF_MONTHLY_INCOME_COPY = "Percentages are shares of your monthly income.";
/** "Avg of 12 complete months", or "Monthly average" when there is no window to name. */
function typicalMonthAverageCopy(windowText) {
    return windowText ? `Avg of ${windowText}` : exports.MONTHLY_AVERAGE_COPY;
}
/** Under "Extra debt payments": the average, then what it is beyond. */
function extraDebtDescriptorCopy(avg) {
    return `${avg}, beyond scheduled payments`;
}
/** The info button's accessible name: "What is monthly income?", "What are bills?". */
function definitionButtonLabel(label) {
    const verb = label === exports.BILLS_LABEL_COPY ? "are" : "is";
    return `What ${verb} ${label.toLowerCase()}?`;
}
/** Shown when a typical month's spending exceeds monthly income. */
function typicalMonthOverCopy(amount) {
    return `A typical month runs ${amount} over your income.`;
}
/** "Average deposits, last 12 months", or the window actually used when it is shorter. */
function averageDepositsLabelCopy(months) {
    return months && months !== 12
        ? `Average deposits, last ${months} months`
        : exports.AVERAGE_DEPOSITS_LABEL_COPY;
}
/* Income (b), Paul 2026-10-15: paychecks left out of monthly income, listed under it.
 * A paycheck counts only when a deposit matched it within its last two cycles. Dates
 * come preformatted, so each app keeps its own date format. */
exports.INCOME_STILL_EXPECTING_COPY = "Still expecting this?";
exports.INCOME_KEEP_COPY = "Keep";
exports.INCOME_REMOVE_COPY = "Remove";
exports.INCOME_UNDO_KEEP_COPY = "Undo";
/** "Side gig: no deposit since Aug 14". */
function incomeStoppedCopy(name, date) {
    return date ? `${name}: no deposit since ${date}` : `${name}: no deposit yet`;
}
/** "Side gig: waiting for its first deposit". */
function incomeWaitingCopy(name) {
    return `${name}: waiting for its first deposit`;
}
/** Under a kept paycheck: it counts until the next pay cycle passes without a deposit. */
exports.INCOME_KEPT_NOTE_COPY = "Counted while you wait for its next deposit.";
//# sourceMappingURL=moneyDefinitionsCopy.js.map